module.exports = __webpack_public_path__ + "img/stop_points_create_dark.8244ffb6.gif";